import dom from "../../dist/jsx-render/dom";
import { app } from "../Frame/App";

/** This is supposed to be run by the app class after initializing the page. It sould init all submenus in dropdowns
 * since bootstrap does not support submenus anymore.
 * 
 * To not interfere with existing dropdowns, these restrictions are in place:
 * 
 * - Structure of the item that toggles the submenu:
 *   <div classname="dropdown-submenu dropleft|dropright">
 *      <a className="dropdown-item dropdown-toggle pointer" data-child-menu="<mySubmenu>" data-id="0">
 *          text
 *      </a>
 *  </div>
 *  
 * - The child menus need the class 'child-menu' and the attribute data-menu-name="<mySubmenu>" 
 * 
 * Partly copied from NewMeasureMenu. */
export class DropdownSubMenus {

    private dropdownRootMenu: HTMLElement;
    private childMenu: HTMLElement;

    //private exampleRootMenu: HTMLElement = <div className="dropdown-menu has-submenus">
    //    <a className="dropdown-item pointer">Submenu Item</a>
    //</div>;

    //private exampleSubMenuItem: HTMLElement = <a className="dropdown-item dropdown-submenu pointer" data-id="0" data-child-menu="mySubmenu">SubMenu</a>

    //private exampleSubMenu: HTMLElement = <div className="dropdown-menu child-menu" data-menu-name="mySubmenu" data-root-menu="idOfRootMenu">
    //    <a className="dropdown-item pointer">Submenu Item</a>
    //</div>;


    public init = (dropdownElement: HTMLElement) => {
        this.dropdownRootMenu = dropdownElement;

        $(dropdownElement).on('shown.bs.dropdown', (ev: Event) => {
            this.checkDropDownHeight(this.dropdownRootMenu?.getBoundingClientRect());
        });

        $(dropdownElement).on('hidden.bs.dropdown', (ev: Event) => {
            this.initializeDropDownHeight();
        });

        let subMenuItems = dropdownElement.querySelectorAll(".dropdown-submenu");
        subMenuItems?.forEach(s => {
            s?.addEventListener('mouseover', this.showDropDownSubMenu);
            s?.addEventListener('mouseleave', this.hideDropDownSubMenu);
            s?.addEventListener('click', this.onClick);

            let childMenuName = s.getAttribute("data-child-menu");
            if (childMenuName) {
                console.log("initializing submenu: " + childMenuName);

                let childMenu = document.querySelector(`.dropdown-menu.child-menu[data-menu-name="${childMenuName}"]`) as HTMLElement;
                if (childMenu) {
                    childMenu.addEventListener('mouseleave', this.hideMenu);

                    let childMenuItems = childMenu.querySelectorAll("a.dropdown-item");
                    childMenuItems.forEach(i => i.addEventListener('click', this.hideParentMenu));
                }
            }
        });
    }


    // Hide the child dropdown 
    hideParentMenu = (ev: Event) => {
        (ev.target as HTMLElement).parentElement.classList.remove('show');
    }

    hideMenu = (ev: Event) => {
        (ev.target as HTMLElement).classList.remove('show');
    }

    // prevent event propagation
    onClick = (ev: MouseEvent) => {
        ev.stopPropagation();
        let target = (ev.target as HTMLElement).closest("div.dropdown-submenu") as HTMLElement;

        this.childMenu = this.getChildElement(target);
        this.childMenu.classList.toggle('show');
        this.setChildMenuPosition(target);
    }

    // show templates list by hover on menuName
    showDropDownSubMenu = (ev: MouseEvent) => {
        let target = (ev.target as HTMLElement).closest("div.dropdown-submenu") as HTMLElement;
        if (target) {
            this.childMenu = this.getChildElement(target);

            if (this.childMenu && !this.childMenu.classList.contains('show')) {
                this.childMenu.classList.add('show');
                this.setChildMenuPosition(target);
            }
        }
    }

    // hide templates list when mouse leave menuName
    hideDropDownSubMenu = (ev: MouseEvent) => {
        let parentElement = ev.target as HTMLElement;
        let relatedTarget = ev.relatedTarget as HTMLElement;
        console.log(relatedTarget);
        this.childMenu = this.getChildElement(parentElement);
        if (relatedTarget && relatedTarget.parentElement && !(relatedTarget.parentElement.classList.contains('child-menu') || relatedTarget.classList.contains("child-menu")))
            this.childMenu?.classList.remove('show');
    }

    // set height value to empty
    initializeDropDownHeight = () => {
        this.dropdownRootMenu.style.height = "";
        this.dropdownRootMenu.classList.remove("overflow-auto");
    }

    // set new height values when list is long
    checkDropDownHeight = (size: any) => {
        if ((size.top + size.height) > window.innerHeight) {
            this.dropdownRootMenu.style.height = (window.innerHeight - size.top - 10) + "px";
            this.dropdownRootMenu.classList.add("overflow-auto");
        }
        else {
            this.initializeDropDownHeight();
        }
    }

    getChildElement = (elem: HTMLElement): HTMLElement => {
        let childMenuName = elem.getAttribute("data-child-menu");
        if (childMenuName) {
            return (document.querySelector(`.dropdown-menu.child-menu[data-menu-name="${childMenuName}"]`));
        } else {
            console.log(`Dropdown sub menu with name '${childMenuName}' not found.`);
        }
    }

    private setChildMenuPosition(parentMenu: HTMLElement) {
        let rect = parentMenu.getBoundingClientRect();

        if (parentMenu.classList.contains("dropleft")) {
            this.childMenu.style.left = `${rect.left - this.childMenu.clientWidth}px`;
            this.childMenu.style.top = `${rect.top}px`;
        }
        else {
            // Show the sub menu to the right of the parent
            this.childMenu.style.left = `${rect.right}px`;
            this.childMenu.style.top = `${rect.top}px`;
        }

        if (!this.childMenu.hasAttribute("use-max-height")) {
            this.childMenu.style.height = (window.innerHeight - rect.top) + "px";
        }
        else {
            this.childMenu.style.maxHeight = (window.innerHeight - rect.top) + "px";
        }

        this.childMenu.classList.add("overflow-auto");
    }
}